import { gql } from "@apollo/client";
import { entryFragments } from "./entryFragments";
import { manualFragments } from "./manualFragments";
// IMPORTANT: do not prettify this file, in my editor when I did so, it removed important commas within the mutation string template.
// prettier-ignore
const QUERY_LIVE_ALL_MANUALS_FOR_SITEID = gql`
query ($siteId: [QueryArgument]) {
  manuals: entries(siteId: $siteId, type: ["product"], section: ["manuals","manualsComposableEntries"]) {
    id
    siteId
    siteHandle
    language
    typeHandle
    # If it's a product
    ... on product_Entry {
      ...ProductEntryFields
    }

    # If it has children that are chapter_Entries
    children {
      id
      ... on chapter_Entry {
        ...ChapterEntryFields
      }
    }
  }
}
# Spread the imported fragments so GraphQL is aware of them.
# You only need to include the "top-level" fragments here.
# The rest will chain because they're nested inside each other.
${entryFragments}

${manualFragments}
`;

export default QUERY_LIVE_ALL_MANUALS_FOR_SITEID;